import type { AccountBadge } from '@olimhub/shared'
import { BadgePill } from '@/components/profile/BadgePill'

interface PostBadgeProps {
  badges: AccountBadge[]
}

export function PostBadge({ badges }: PostBadgeProps) {
  const visible = badges.filter((ab) => ab.isVisible && ab.badge.showOnPosts)
  if (visible.length === 0) return null
  return <BadgePill accountBadge={visible[0]} size="sm" />
}
